module.exports = __webpack_public_path__ + "static/media/bg-mod.432fa8b5.png";